<script setup lang="ts">
const {
  canInstall,
  installed,
  isStandalone,
  isIos,
  showIosInstallGuide,
  promptInstall,
  dismissIosInstallGuide,
} = usePwaInstall()

const show = computed(
  () =>
    !installed.value &&
    !isStandalone.value &&
    (canInstall.value || (isIos.value && showIosInstallGuide.value)),
)

const onInstallClick = async () => {
  await promptInstall()
}

function dismissGuide() {
  dismissIosInstallGuide?.()
}
</script>

<template>
  <transition name="fade">
    <div v-if="show" class="fixed bottom-4 left-4 right-4 z-50 sm:bottom-6">
      <div
        class="mx-auto flex max-w-xl items-center gap-4 rounded-[2rem] border-2 border-blue-100 bg-white p-4 shadow-[0_12px_28px_rgba(13,72,145,0.22)] sm:p-5"
      >
        <div
          class="flex size-16 shrink-0 items-center justify-center overflow-hidden rounded-full bg-[#1678e5] shadow-sm"
        >
          <img
            src="/img/mascot/mascot-splash.webp"
            alt=""
            aria-hidden="true"
            class="mt-3 w-14 max-w-none"
          >
        </div>
        <div class="min-w-0 flex-1">
          <p class="font-[Fredoka] text-xl font-semibold text-[#1678e5]">
            {{
              isIos ? 'Add WLearn to your Home Screen' : 'Take WLearn with you'
            }}
          </p>
          <p class="text-sm leading-5 text-slate-600">
            <template v-if="isIos">
              In Safari, tap
              <UIcon name="i-lucide-share" class="inline-block size-4" /> Share,
              then <strong>Add to Home Screen</strong>.
            </template>
            <template v-else
              >Use it offline and from your home screen.</template
            >
          </p>
        </div>
        <button
          v-if="!isIos"
          class="min-h-12 shrink-0 cursor-pointer rounded-full bg-[#1678e5] px-5 py-2 font-[Fredoka,Montserrat,sans-serif] text-lg font-semibold text-white shadow-[0_5px_0_#0d4891] transition-[transform,box-shadow,background] duration-150 hover:-translate-y-0.5 hover:bg-[#2f8cf1] active:translate-y-[3px] active:shadow-[0_2px_0_#0d4891]"
          @click="onInstallClick"
        >
          Install
        </button>
        <button
          v-else
          type="button"
          class="shrink-0 rounded-full p-3 text-slate-500 hover:bg-slate-100"
          aria-label="Dismiss install instructions"
          @click="dismissGuide"
        >
          <UIcon name="i-lucide-x" class="size-5" />
        </button>
      </div>
    </div>
  </transition>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
